import styled from '@emotion/styled';

/**
 * Fixed-position overlay that hosts the MessageTestingResultsPanel.
 * Use `$side="right"` when chat is on the left (panel appears on the right),
 * and `$side="left"` when chat is on the right (panel appears on the left).
 */
export const MessageTestingOverlay = styled.div<{ $side: 'left' | 'right' }>`
  position: fixed;
  top: 72px;
  ${(p) => (p.$side === 'right' ? 'right: 12px;' : 'left: 12px;')}
  bottom: 12px;
  width: 60%;
  max-width: 900px;
  z-index: 1200;
  display: flex;
  flex-direction: column;
`;
